<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="text-center">
                Copyright © 2023 | 
                <a target="_blank" href="https://candidonlinemarketing.com">Candid Online Marketing</a>, 
                All rights reserved.
                <span class="app-version" v-if="appVersion" :title="buildTimeFormatted">
                    v{{ appVersion }}
                </span>
            </p>
        </div>
        <div class="footer-section f-section-2">
            <p class="">
                Coded with
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-heart"
                >
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
            </p>
        </div>
    </div>
    <!-- END FOOTER -->
</template>

<script>
export default {
    data() {
        return {
            appVersion: process.env.VUE_APP_VERSION || null,
            buildTime: process.env.VUE_APP_BUILD_TIME || null
        };
    },
    computed: {
        buildTimeFormatted() {
            if (!this.buildTime) return '';
            try {
                return `Built: ${new Date(this.buildTime).toLocaleString()}`;
            } catch (e) {
                return 'Build time unknown';
            }
        }
    },
    mounted() {
        // Listen for service worker updates
        window.addEventListener('sw-updated', (event) => {
            this.appVersion = event.detail.version;
            this.buildTime = event.detail.buildTime;
        });
        
        // Check localStorage for cached version info
        const cachedVersion = localStorage.getItem('app_version');
        const cachedBuildTime = localStorage.getItem('app_build_time');
        
        if (cachedVersion) {
            this.appVersion = cachedVersion;
        }
        if (cachedBuildTime) {
            this.buildTime = cachedBuildTime;
        }
    },
    methods: {}
};
</script>

<style scoped>
.app-version {
    font-size: 0.8em;
    color: #888;
    margin-left: 8px;
    padding: 2px 6px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    cursor: help;
    transition: all 0.2s ease;
}

.app-version:hover {
    background-color: rgba(0,0,0,0.2);
    color: #333;
}
</style>
